import type { RouteObject } from "react-router-dom";
import { Suspense, lazy } from "react";
import LoadingSpinner from "../components/feature/LoadingSpinner";
import NotFound from "../pages/NotFound";
const Home = lazy(() => import("../pages/home/page"));
import Contact from "../pages/contact/page";
import About from "../pages/about/page";
import Impressum from "../pages/impressum/page";
import Datenschutz from "../pages/datenschutz/page";
import Agb from "../pages/agb/page";
import Blog from "../pages/blog/page";
import BlogDetail from "../pages/blog/detail/page";
import BhsModell from "../pages/bhs-modell/page";
import Faq from "../pages/faq/page";
import HeroBanners from "../pages/hero-banners/page";
import Preview from "../pages/preview/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Suspense fallback={<LoadingSpinner />}><Home /></Suspense>,
  },
  {
    path: "/kontakt",
    element: <Contact />,
  },
  {
    path: "/ueber-mich",
    element: <About />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:id",
    element: <BlogDetail />,
  },
  {
    path: "/bhs-modell",
    element: <BhsModell />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/hero-banners",
    element: <HeroBanners />,
  },
  {
    path: "/impressum",
    element: <Impressum />,
  },
  {
    path: "/datenschutz",
    element: <Datenschutz />,
  },
  {
    path: "/agb",
    element: <Agb />,
  },
  {
    path: '/api/preview',
    element: <Preview />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
